import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { useAddActivityStakeholderLinkMutation, useAddIroStakeholderLinkMutation, useAddStakeholderMutation, useListStakeholdersQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddStakeholder',
  emits: ['done'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var attrs = useAttrs();
    var name = ref('');
    var description = ref('');
    var nameRef = ref(null);
    var descriptionRef = ref(null);
    var _useAddStakeholderMut = useAddStakeholderMutation(),
      addStakeholder = _useAddStakeholderMut.mutate,
      loading = _useAddStakeholderMut.loading;
    var _useAddIroStakeholder = useAddIroStakeholderLinkMutation(),
      addIroStakeholderLink = _useAddIroStakeholder.mutate;
    var _useAddActivityStakeh = useAddActivityStakeholderLinkMutation(),
      addActivityStakeholderLink = _useAddActivityStakeh.mutate;
    var menuModel = ref(false);
    var search = ref('');
    var onKeyDown = function onKeyDown(e) {
      if (e.code === 'Enter') {
        menuModel.value = true;
        name.value = search.value;
        search.value = ''; // clear the old one

        // FIXME: this doesn't work
        // nextTick().then(() => {
        //   nameRef.value.focus()
        // })
        setTimeout(function () {
          nameRef.value.focus();
          descriptionRef.value.focus();
        }, 300);
      }
    };
    var onChange = function onChange(e) {
      // when a valid stakeholder is clicked, link it!
      if (attrs['activity-id']) {
        addActivityStakeholderLink({
          stakeholderId: e,
          activityId: attrs['activity-id']
        }).then(function () {
          emit('done');
          search.value = '';
          refetch();
        });
      } else {
        addIroStakeholderLink({
          stakeholderId: e,
          iroId: attrs['iro-id']
        }).then(function () {
          emit('done');
          search.value = '';
          refetch();
        });
      }
    };
    var type = ref();
    var _useListStakeholdersQ = useListStakeholdersQuery(computed(function () {
        return {
          filters: {
            notLinkedToActivities: attrs['activity-id'] ? [attrs['activity-id']] : [],
            notLinkedToIros: attrs['iro-id'] ? [attrs['iro-id']] : []
          }
        };
      })),
      result = _useListStakeholdersQ.result,
      refetch = _useListStakeholdersQ.refetch;
    var stakeholders = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listStakeholders;
    });
    return {
      __sfc: true,
      attrs: attrs,
      emit: emit,
      name: name,
      description: description,
      nameRef: nameRef,
      descriptionRef: descriptionRef,
      addStakeholder: addStakeholder,
      loading: loading,
      addIroStakeholderLink: addIroStakeholderLink,
      addActivityStakeholderLink: addActivityStakeholderLink,
      menuModel: menuModel,
      search: search,
      onKeyDown: onKeyDown,
      onChange: onChange,
      type: type,
      result: result,
      refetch: refetch,
      stakeholders: stakeholders
    };
  }
});